/** Small blue verified-creator checkmark badge. */
export function VerifiedBadge({ className = "" }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Verified creator"
      title="Verified creator"
      className={`inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-[#1d9bf0] text-white align-middle ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-2.5 w-2.5"
        aria-hidden="true"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </span>
  );
}

export default VerifiedBadge;